import { data } from 'jquery';
import apiurl from './apiurl';
const axios = require('axios');

const obj= {
    updateDevice: async (idToken,params) =>        
    axios({
        'method':'put',
        'url':apiurl +'updateDevice',
        'headers': {
            'content-type':'application/json',
            'Authorization':"Bearer "+idToken
        },
        data: params,
        'crossdomain': true,
    })
    
};

export default obj;